import { actionTypes } from "../actions/default.action"

const initialState = {
  affiliateLogos: {
    data: [],
  },
  affiliateLogo: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        affiliateLogos: {
          ...state.affiliateLogos,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        affiliateLogos: {
          ...state.affiliateLogos,
          data: state.affiliateLogos.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        affiliateLogo: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
